import { provideState } from '@ngrx/store';
import { layoutFeature } from './layout.reducer';

export const LayoutFeatureProviders = [
  provideState(layoutFeature),
];
